import React, { Component } from "react";
import cns from "classnames";
import { isEmpty } from "lodash";
import { withStyles } from "@material-ui/core";
import Body from "@components/typography/Body";
import locale from "@bonliva-crm/locale";
import { ThemeType, Classes } from "@theme";

type OwnProps = {
  children?: React.ReactNode;
  content?: React.ReactNode;
  groupByOptions?: LabelValue[];
  groupBy?: string;
  onGroupBy?: (value: string) => any;
  total?: number;
  /** todo: remove this later and let the search pages to decide */
  fitted?: boolean;
  /** todo: remove this later and let the search pages to decide */
  fittedContent?: boolean;
  style?: React.CSSProperties;
};

type Props = OwnProps & {
  classes: Classes<typeof styles>;
};

/**
 * Puts search result items into a table
 */
export class SearchResultLayout extends Component<Props> {
  renderGrouping = () => {
    const { classes, groupBy, groupByOptions, onGroupBy } = this.props;

    if (isEmpty(groupByOptions)) {
      return null;
    }

    return (
      <div className={classes.title}>
        <div className={classes.groupBy}>
          <Body>{locale.GroupBy}:</Body>
          {groupByOptions.map((option) => (
            <Body
              key={option.value}
              data-active={groupBy === option.value}
              onClick={() => onGroupBy && onGroupBy(option.value)}
            >
              {option.label}
            </Body>
          ))}
        </div>
      </div>
    );
  };

  render() {
    const { classes, content, children, fitted, fittedContent } = this.props;

    const _content = content ? content : children;

    return (
      <div
        className={cns(classes.root, { [classes.padded]: !fitted })}
        style={this.props.style}
      >
        {this.renderGrouping()}
        <div className={cns({ [classes.content]: !fittedContent })}>{_content}</div>
      </div>
    );
  }
}

const styles = (theme: ThemeType) => ({
  root: {
    ...theme.fixedGrid
  },

  padded: {
    padding: theme.spacing(2)
  },

  title: {
    marginBottom: theme.spacing()
  },

  count: {
    float: "right"
  },

  content: {
    "& > div > *": {
      marginBottom: theme.spacing(2)
    }
  },

  groupBy: {
    marginBottom: theme.spacing(),

    "& > *": {
      display: "inline-block",
      marginRight: theme.spacing(1 / 2)
    },

    "& > *:not(:last-child):not(:first-child):after": {
      content: "'|'",
      display: "inline-block",
      marginLeft: theme.spacing(1 / 2)
    },

    "& > *[data-active=true]": {
      fontWeight: 600
    },

    "& > *[data-active=false]": {
      cursor: "pointer"
    }
  }
});

export default withStyles(styles as any)(SearchResultLayout);
